module.exports = __webpack_public_path__ + "img/中国石油化工股份有限公司洛阳分公司.479ff9ff.jpg";